// extracted by mini-css-extract-plugin
module.exports = {"app":"app_app__1QEGA","colorBoard":"app_colorBoard__fDaEe","Footer":"app_Footer__3Hrbo","current":"app_current__2pYWX"};